import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=a28ddd50&scoped=true"
import script from "./IntegrationView.vue?vue&type=script&lang=js"
export * from "./IntegrationView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationView.vue?vue&type=style&index=0&id=a28ddd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28ddd50",
  null
  
)

export default component.exports